export default __webpack_public_path__ + "static/media/larvia-light.d5c8b74a.svg";